<div class="OutsideContainer Flexbox Flexbox--column" #Container>
  <div class="Container Grid Gap--smaller">
    <mat-card *ngFor="let width of widthsToShow()" #WidthCard [class.Selected]="selectedWidth()?.id === width.id" [class.Unavailable]="!reachableWidths().includes(width.id)">
      <mat-card-content>
        <button mat-flat-button (click)="selectWidth(width)">
          <div class="Flexbox Flexbox--column Align--center ButtonContent Gap--normal">
            <img [src]="getImageURL(width.displayName)">
            <div class="ButtonName Flexbox Align--center">
              <span>{{ width.displayName }}</span>
            </div>
            <!-- <app-selection-indicator [isVisible]="selectedWidth() === width" [shouldAnimate]="shouldAnimateSelection" [isUnavailable]="!availableWidths.includes(width)"></app-selection-indicator> -->
          </div>
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>